import { Outlet, Link, useLocation } from 'react-router-dom'
import { useState } from 'react'
import { useAuth } from '../contexts/AuthContext'
import { useTranslation } from 'react-i18next'
import { LanguageToggle } from './LanguageToggle'

export function Layout() {
  const { user, signInWithGoogle, signOut } = useAuth()
  const location = useLocation()
  const { t } = useTranslation()

  const navItems = [
    { path: '/dashboard', label: t('dashboard.title') },
    { path: '/test-cases', label: t('testCases.title') },
    { path: '/metrics', label: t('dashboard.metrics.title', 'Metrics') },
    { path: '/iqai', label: 'IQAI' },
  ]

  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)

  return (
    <div className="min-h-screen d-flex flex-column">
      {/* Header */}
      <header className="bg-primary-default text-pure-0 shadow-md">
        <div className="br-container px-4">
          <div className="d-flex align-items-center justify-content-between py-2">
            {/* Left side: Logo + Title + Nav */}
            <div className="d-flex align-items-center gap-4">
              {/* Logo + Title */}
              <Link to="/" className="d-flex align-items-center gap-3 text-pure-0" style={{ textDecoration: 'none' }}>
                <img
                  src="/logo-lumen.svg"
                  alt="Lumen Framework"
                  className="logo-responsive bg-pure-0 rounded px-2 py-1"
                />
                <div className="d-none d-sm-flex flex-column">
                  <span className="text-weight-bold" style={{ fontSize: '1.25rem' }}>Lumen Framework</span>
                  <span className="text-gray-10" style={{ fontSize: '0.75rem' }}>Interfaces Generativas</span>
                </div>
              </Link>

              {/* Navigation - Desktop */}
              <nav className="d-none d-md-flex align-items-center gap-4">
                {navItems.map((item) => (
                  <Link
                    key={item.path}
                    to={item.path}
                    className={`transition-colors px-2 py-1 rounded-lg ${location.pathname === item.path
                      ? 'text-pure-0 font-semibold bg-primary-darken-01'
                      : 'text-gray-10'
                      }`}
                    style={{ textDecoration: 'none' }}
                  >
                    {item.label}
                  </Link>
                ))}
              </nav>

              {/* Mobile menu button */}
              <button
                className="d-md-none bg-transparent border-0 text-pure-0 p-2"
                onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                aria-label="Toggle menu"
              >
                ☰
              </button>
            </div>

            {/* Right side: Language Toggle + Auth */}
            <div className="d-flex align-items-center gap-4">
              <LanguageToggle />
              {user ? (
                <>
                  <span className="text-sm d-none d-sm-inline">
                    {user.displayName || user.email}
                  </span>
                  <button
                    onClick={signOut}
                    className="bg-pure-0 text-primary-default px-3 py-1 rounded font-semibold hover-bg-gray-2 transition-colors border-0"
                  >
                    {t('common.logout')}
                  </button>
                </>
              ) : (
                <button
                  onClick={signInWithGoogle}
                  className="bg-pure-0 text-primary-default px-3 py-1 rounded font-semibold hover-bg-gray-2 transition-colors border-0"
                >
                  {t('common.signIn', 'Sign in with Google')}
                </button>
              )}
            </div>
          </div>

          {/* Mobile Menu */}
          {mobileMenuOpen && (
            <nav className="d-md-none py-3 border-t border-primary-darken-01">
              <div className="d-flex flex-column gap-2">
                {navItems.map((item) => (
                  <Link
                    key={item.path}
                    to={item.path}
                    onClick={() => setMobileMenuOpen(false)}
                    className={`px-3 py-2 rounded-lg ${location.pathname === item.path
                      ? 'bg-primary-darken-01 font-semibold'
                      : ''
                      }`}
                    style={{ textDecoration: 'none', color: 'white' }}
                  >
                    {item.label}
                  </Link>
                ))}
              </div>
            </nav>
          )}
        </div>
      </header>

      {/* Main Content */}
      <main className="flex-1 br-container px-4 py-8">
        <Outlet />
      </main>

      {/* Footer */}
      <footer className="bg-primary-darken-02 text-pure-0 py-4">
        <div className="br-container px-4 text-center">
          <p className="text-sm">
            Lumen POC - Framework GenUI for TST
          </p>
          <p className="text-xs text-gray-20 mt-1">
            University of Brasília
          </p>
        </div>
      </footer>
    </div>
  )
}
